module.exports = __webpack_public_path__ + "img/MDI-folder-upload-outline.1c45bb05.svg";